module.exports = __webpack_public_path__ + "static/media/car2.7d20ed88.svg";